import { HttpClient } from '../http-client';
export var SpaceTabDocumentType = /*#__PURE__*/ function(SpaceTabDocumentType) {
    SpaceTabDocumentType["RocketlaneDocument"] = "ROCKETLANE_DOCUMENT";
    SpaceTabDocumentType["EmbedableDocument"] = "GOOGLE_DOCUMENT";
    return SpaceTabDocumentType;
}({});
export var SpaceTabType = /*#__PURE__*/ function(SpaceTabType) {
    SpaceTabType["Project"] = "PROJECT";
    SpaceTabType["ProjectTemplate"] = "PROJECT_TEMPLATE";
    SpaceTabType["DocumentTemplate"] = "DOCUMENT_TEMPLATE";
    return SpaceTabType;
}({});
class SpaceTabHttpClient extends HttpClient {
    async getSpaceTab(spaceTabId) {
        return this.get(`/space-tabs/${spaceTabId}`);
    }
    async getSpaceId(spaceTabId) {
        return this.get(`/space-tabs/${spaceTabId}/get-space-id`);
    }
    // TODO: @Krishna remove ? once the sagas are removed
    async createSpaceTab(payload) {
        return this.post('/space-tabs', payload);
    }
    async updateSpaceTab(spaceTabId, data) {
        return this.put(`/space-tabs/${spaceTabId}`, data);
    }
    async deleteSpaceTab(spaceTabId) {
        return this.delete(`/space-tabs/${spaceTabId}`);
    }
    async updateLastSeen(projectId, spaceTabId) {
        return this.post(`/projects/${projectId}/space-tabs/${spaceTabId}/last-seen`);
    }
}
export const SpaceTabAPI = new SpaceTabHttpClient();
